import React from "react";
import { Link } from "react-router-dom";
import FooterLogo from "../Assets/img/footer-logo.png";
const Footer = () => {
  return (
    <>
      {/* <!-- Footer-Area --> */}
      <footer className="footer-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <div className="footer-top-inner">
                <div className="row">
                  {/* <!-- Single-Widget --> */}
                  <div className="col-lg-5 col-md-6 col-12">
                    <div className="single-widget footer-about">
                      <div className="footer-logo">
                        <Link className="logo" to="/">
                          <img src={FooterLogo} alt="#" />
                        </Link>
                      </div>
                      <div className="about-description">
                        <p>
                          Turn up results for your business billing and
                          management platform built for lean, efficient growth.
                        </p>
                        <span className="copyright-content">
                          ©2020 ISP Digital | A Complete ISP Billing &
                          Management Software for ISP Business All rights
                          reserved
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Single-Widget --> */}
                  <div className="col-lg-2 col-md-6 col-12">
                    <div className="single-widget quick-links">
                      <div className="widget-title">
                        <h3>Quick Links</h3>
                      </div>
                      <ul>
                        <li>
                          <Link to="/aboutus">About ISP Digital</Link>
                        </li>
                        <li>
                          <Link to="/webfeature">Features</Link>
                        </li>
                        <li>
                          <Link to="/changelog">Change log</Link>
                        </li>
                        <li>
                          <Link to="/webfaq">Faq's</Link>
                        </li>
                        <li>
                          <Link to="/blog">The Blog</Link>
                        </li>
                        <li>
                          <Link to="/offerpage">Offer/ Promotion</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <!-- Single-Widget --> */}
                  <div className="col-lg-2 col-md-6 col-12">
                    <div className="single-widget company">
                      <div className="widget-title">
                        <h3>Company</h3>
                      </div>
                      <ul>
                        <li>
                          <Link to="/aboutus">About company</Link>
                        </li>
                        <li>
                          <Link to="/webknowledgebase">Knowledge base</Link>
                        </li>
                        <li>
                          <Link to="/websubscription">Subscription</Link>
                        </li>
                        <li>
                          <Link to="/termscondition">Terms & Condition</Link>
                        </li>
                        <li>
                          <Link to="/privacypolicy">Privacy Policy</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <!-- Single-Widget --> */}
                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="single-widget lets-contact mb-0">
                      <div className="widget-title">
                        <h3>Lets Connect</h3>
                      </div>
                      <div className="footer-lets-contact">
                        <ul>
                          <li>
                            <a href="mailto:sales@softifybd.com">
                              <i className="icofont-envelope"></i>
                              sales@softifybd.com
                            </a>
                          </li>
                          <li>
                            <a href="tel:+8801842117900">
                              <i className="fa fa-whatsapp"></i>+8801842117900
                            </a>
                          </li>
                          <li>
                            <a href="tel:+8801842117906">
                              {" "}
                              <i className="fa fa-whatsapp"></i>+8801842117906
                            </a>
                          </li>
                          <li>
                            <a href="tel:+8801842117903">
                              {" "}
                              <i className="fa fa-whatsapp"></i>+8801842117903
                            </a>
                          </li>
                          <li>
                            <a href="tel:+8801730797262">
                              {" "}
                              <i className="fa fa-whatsapp"></i>+8801730797262
                            </a>
                          </li>
                          <li>
                            <a href="tel:+8809613228899">
                              <i className="icofont-phone"></i>+8809613228899
                            </a>
                          </li>
                        </ul>
                        <form
                          action="#"
                          method="post"
                          className="newsletter-area"
                        >
                          <input
                            type="email"
                            placeholder="Enter email address"
                          />
                          <button className="submit-btn" type="submit">
                            <i className="icofont-paper-plane"></i>
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                  {/* <!-- End-Single-Widget -->
					<!-- Footer Office Widget --> */}
                  <div className="col-lg-5 col-md-6 col-12">
                    <div className="footer-office-widget">
                      <h4 className="footer-office-title">
                        <i className="icofont-google-map"></i>Development Office
                      </h4>
                      <p>
                        Hazi Motaleb Plaza(4th Floor), Bandar,
                        <br />
                        Narayanganj, Bangladesh.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-6 col-12">
                    <div className="footer-office-widget">
                      <h4 className="footer-office-title">
                        <i className="icofont-google-map"></i>Corporate Office
                      </h4>
                      <p>
                        Flat #B4, House No:71, Road:27, Gulshan-1,
                        <br />
                        Dhaka 1212, Bangladesh.
                      </p>
                    </div>
                  </div>
                  {/* <!-- End Footer Office Widget --> */}
                </div>
                <div className="row">
                  <div className="col-12">
                    <ul className="footer-social">
                      <li>
                        <a href="#" target="_blank">
                          <i className="icofont-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.facebook.com/ispdigital/"
                          target="_blank"
                        >
                          <i className="icofont-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank">
                          <i className="icofont-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank">
                          <i className="icofont-linkedin"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank">
                          <i className="icofont-youtube-play"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* <!-- End Footer --> */}
    </>
  );
};

export default Footer;
